import { styled } from '@mui/material/styles';

export const StyledLocationWrapper = styled('div')(
  ({ theme }) => `
    max-width: 316px;
    padding: ${theme.DS_spacing(['md'])};
  `,
);

export const StyledLocationHeader = styled('div')(
  () => `
    width: 100%;
    height: 30px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
  `,
);

export const StyledBookButtonWrapper = styled('div')(
  ({ theme }) => `
    div.fix-width {
      margin-top: 6px;
    }
  
    a {
      padding: ${theme.DS_spacing(['xs'])};
      min-width: 100% !important;
      max-height: 56px;
      min-height: auto;
    }
  `,
);
